import React from "react";
import { useSelector } from "react-redux";
import styles from "./AnprPromoCard.module.css";

const PROMO_URL =
  "https://www.ticketcontrol.net/camaras?utm_source=monitor&utm_medium=banner&utm_campaign=anpr_upsell";

/**
 * Card publicitaria que invita a integrar cámaras con IA (módulo ANPR).
 * Solo se muestra a clientes que AÚN NO tienen el módulo ANPR activo.
 * Se renderiza al final del Dashboard. Siempre visible (sin opción de cerrar).
 */
const AnprPromoCard = () => {
  const appConfig = useSelector((state) => state.data.appConfig) || {};
  const configLoaded = Object.keys(appConfig).length > 0;
  const anprActive = appConfig?.modules?.anpr === 1;

  // No mostrar hasta que la config esté cargada (garantiza cero parpadeo en
  // clientes con ANPR), ni si el cliente ya tiene el módulo ANPR activo.
  if (!configLoaded || anprActive) return null;

  return (
    <div className={styles.card}>
      <img
        className={styles.capture}
        src="/assets/promo/captura.png"
        alt="Reconocimiento de vehículos con IA"
      />

      <div className={styles.text}>
        <span className={styles.badge}>INTELIGENCIA ARTIFICIAL</span>
        <div className={styles.title}>¿Todavía no pegaste el salto?</div>
        <p className={styles.subtitle}>
          Sumá cámaras con IA y controlá cada entrada y cada salida. Registro automático de
          todos los vehículos con o sin matrícula, reconocimiento de clientes abonados
          (mensuales) y más recaudación.
        </p>
        <a className={styles.cta} href={PROMO_URL} target="_blank" rel="noopener noreferrer">
          Conocé las cámaras IA
          <span className="material-symbols-rounded" style={{ fontSize: 18, marginLeft: 4 }}>arrow_forward</span>
        </a>
      </div>

      <img
        className={styles.camera}
        src="/assets/promo/equipos_cam.png"
        alt="Cámara ANPR Dahua"
      />
    </div>
  );
};

export default AnprPromoCard;
